import { render, staticRenderFns } from "./setFee.vue?vue&type=template&id=42f1759f&scoped=true"
import script from "./setFee.vue?vue&type=script&lang=js"
export * from "./setFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f1759f",
  null
  
)

export default component.exports